/* eslint-disable @typescript-eslint/unbound-method */

import { ReservationApi } from "@/apis/clients";
import { wrap } from "@/apis/wrap";

const reservationApi = {
  indexReservation: wrap(
    ReservationApi,
    ReservationApi.prototype.indexReservation,
  ),
  csvReservation: wrap(ReservationApi, ReservationApi.prototype.csvReservation),
  showReservation: wrap(
    ReservationApi,
    ReservationApi.prototype.showReservation,
  ),
  showCalendarReservation: wrap(
    ReservationApi,
    ReservationApi.prototype.showCalendarReservation,
  ),
  getCalendarReservationApplication: wrap(
    ReservationApi,
    ReservationApi.prototype.getCalendarReservationApplication,
  ),
  showReservationCustomer: wrap(
    ReservationApi,
    ReservationApi.prototype.showReservationCustomer,
  ),
  indexReservationPaymentDunningMail: wrap(
    ReservationApi,
    ReservationApi.prototype.indexReservationPaymentDunningMail,
  ),
  updateReservationHoldDate: wrap(
    ReservationApi,
    ReservationApi.prototype.updateReservationHoldDate,
  ),
  cancelReservation: wrap(
    ReservationApi,
    ReservationApi.prototype.cancelReservation,
  ),
  updateReservationMemo: wrap(
    ReservationApi,
    ReservationApi.prototype.updateReservationMemo,
  ),
  updateReservationComplete: wrap(
    ReservationApi,
    ReservationApi.prototype.updateReservationComplete,
  ),
  updateReservationUnpaid: wrap(
    ReservationApi,
    ReservationApi.prototype.updateReservationUnpaid,
  ),
  deleteReservation: wrap(
    ReservationApi,
    ReservationApi.prototype.deleteReservation,
  ),
  updateCalendarReservation: wrap(
    ReservationApi,
    ReservationApi.prototype.updateCalendarReservation,
  ),
  orderCalendarReservation: wrap(
    ReservationApi,
    ReservationApi.prototype.orderCalendarReservation,
  ),
};

export default reservationApi;
